import { render, staticRenderFns } from "./Orga_EachID.vue?vue&type=template&id=6f11be13&scoped=true"
import script from "./Orga_EachID.vue?vue&type=script&lang=js"
export * from "./Orga_EachID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f11be13",
  null
  
)

export default component.exports